import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=0200aea2&scoped=true"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&id=0200aea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0200aea2",
  null
  
)

export default component.exports